export default {
  users: [],
  organizations: [],
  current_page: 1,
  last_page: 1,
  per_page: 20,
  total: 1,
  trash: {
    users: [],
    last_page: 0,
    total: 0,
    result: []
  },
  user_online: []
}



// WEBPACK FOOTER //
// ./src/store/module/user/state.js